import React, { useState } from 'react';
import { PlayIcon } from 'lucide-react';
interface CourseVideoProps {
  url: string;
  poster: string;
  title: string;
  caption: string;
}

// 16:9 video slot. Shows a poster with a play button; loads the embed only when played.
// With no URL yet, it shows a clear "video coming soon" placeholder.
export function CourseVideo({
  url,
  poster,
  title,
  caption
}: CourseVideoProps) {
  const [playing, setPlaying] = useState(false);
  const hasVideo = url.trim().length > 0;
  return <figure data-id="element-293" data-mp="2a2ya8zaju9hs">
      <div className="relative aspect-video w-full overflow-hidden rounded-[28px] bg-mist md:rounded-[40px]" data-id="element-294" data-mp="2a36nisal3gti">
        {playing && hasVideo ? <iframe src={`${url}${url.includes('?') ? '&' : '?'}autoplay=1`} title={title} className="absolute inset-0 h-full w-full" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen data-id="element-295" data-mp="2nvejihu1n3r5" /> : <>
            <img src={poster} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-296" data-mp="grmotnp2cbg7" />
            <div className="absolute inset-0 bg-black/25" aria-hidden="true" data-id="element-297" data-mp="lqppyx1x9xiw" />
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 p-6 text-center" data-id="element-298" data-mp="lomptk722o0g">
              <button type="button" onClick={() => hasVideo && setPlaying(true)} disabled={!hasVideo} aria-label={hasVideo ? `Play video: ${title}` : 'Video coming soon'} className="group flex h-20 w-20 items-center justify-center rounded-full bg-brand text-white transition-transform duration-150 ease-brand hover:scale-105 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white disabled:cursor-default disabled:hover:scale-100 md:h-24 md:w-24" data-id="element-299" data-mp="qjseurvr8isr">
                <PlayIcon className="ml-1 h-8 w-8 fill-current md:h-10 md:w-10" aria-hidden="true" data-id="element-300" data-mp="1j5k454o7utki" />
              </button>
              {!hasVideo ? <span className="rounded-full bg-white px-3 py-1 type-small font-bold text-ink" data-id="element-301" data-mp="3k82vx1v17ks5">Video coming soon</span> : null}
            </div>
          </>}
      </div>
      <figcaption className="mt-5 flex flex-col gap-1 md:flex-row md:items-baseline md:justify-between md:gap-8" data-id="element-302" data-mp="3t90xldhzzg7k">
        <span className="type-card-title text-ink" data-id="element-303" data-mp="3o9eo9f5aik41">{title}</span>
        <span className="max-w-xl type-card-desc text-body" data-id="element-304" data-mp="3o7tvnv2jdb8t">{caption}</span>
      </figcaption>
    </figure>;
}